import metadata from './publicMeta.json';
export const publicLocales = Object.keys(metadata);
export function publicRoute(pathname) {
  const match = /^\/(?:([a-z]{2}(?:-[A-Z]{2})?)(?:\/|$))?(chatgpt\/?)?$/.exec(pathname);
  if (!match || match[1] === 'en' || (match[1] && !metadata[match[1]])) return null;
  return {locale: match[1] || 'en', page: match[2] ? 'chatgpt' : 'home'};
}
export function publicPath(locale, page = 'home') {
  return (locale === 'en' ? '/' : '/' + locale + '/') + (page === 'chatgpt' ? 'chatgpt/' : '');
}
export function publicMetadata(pathname) {
  const route = publicRoute(pathname);
  return route ? metadata[route.locale][route.page] : null;
}
export function localizePublicLink(to, locale) {
  if (typeof to !== 'string' || !to.startsWith('/')) return to;
  const [pathname] = to.split(/[?#]/);
  if (/^\/guides\/(?:[^/]+\/)?$/.test(pathname)) return (locale === 'en' ? '' : '/' + locale) + to;
  const route = publicRoute(pathname);
  return route ? publicPath(locale, route.page) + to.slice(pathname.length) : to;
}
